"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var web_utils_1 = require("@ubeeqo/web-utils");
var lodash_1 = require("lodash");
require("reflect-metadata");
function requestTypeGuard(target, propertyKey, propertyDesciptor) {
    var paramsTypes = Reflect.getMetadata('design:paramtypes', target, propertyKey);
    propertyDesciptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        lodash_1.each(args, function (param) {
            var type = typeof param;
            web_utils_1.logger.message({ type: type, paramsTypes: paramsTypes }, web_utils_1.LOG_TYPE.info);
        });
    };
    return propertyDesciptor;
}
exports.requestTypeGuard = requestTypeGuard;
